import { createContext } from 'react';
import {
    QUERY_KEYS_SECURITY,
    useChartsData
} from '../../../../Common/hooks/useChartsData';
import { useSecurityFiltersContext } from '../../../Common/Filters/hooks/useSecurityFiltersContext';

export const PoliceChartsDataContext = createContext();

const PoliceChartsDataProvider = ({ children }) => {
    const { filters } = useSecurityFiltersContext();
    const currentYear = new Date().getFullYear();
    const filterParams = {
            year: JSON.stringify(filters.year?.value || filters.year || currentYear),
            month: filters.month?.value ? String(Number(filters.month?.value)) : "",
            location: filters.unidade.value,
            city: filters.cidade?.value,
    }

    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.POLICE_INTERVENTION_DEATHS_POLICE_BY_CORPORATE,
            url: 'governanceroom/securitydashboard/deathsByPoliceIntervention/police/byCorporate'
        },
        filterParams
    );

    const bySituationData = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.POLICE_INTERVENTION_DEATHS_POLICE_BY_SITUATION,
            url: 'governanceroom/securitydashboard/deathsByPoliceIntervention/police/bySituation'
        },
        filterParams
    );

    const byMunicipalityData = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.POLICE_INTERVENTION_DEATHS_POLICE_BY_MUNICIPALITY,
            url: 'governanceroom/securitydashboard/deathsByPoliceIntervention/police/byMunicipality'
        },
        filterParams
    );

    const byPoliceStationData = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.POLICE_INTERVENTION_DEATHS_POLICE_BY_POLICE_STATION,
            url: 'governanceroom/securitydashboard/deathsByPoliceIntervention/police/byPoliceStation'
        },
        filterParams
    );

    const byDepartmentData = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.POLICE_INTERVENTION_DEATHS_POLICE_BY_DEPARTMENT,
            url: 'governanceroom/securitydashboard/deathsByPoliceIntervention/police/byDepartment'
        },
        filterParams
    );

    const chartData = {
        byCorporateAnual: data?.anualEvolution || [],
        byCorporateMonth: data?.monthEvolution || [],
        bySituationAnual: bySituationData?.data?.anualEvolution || [],
        bySituationMonth: bySituationData?.data?.monthEvolution || [],
        byMunicipalityAnual: byMunicipalityData?.data?.anualEvolution || [],
        byMunicipalityMonth: byMunicipalityData?.data?.monthEvolution || [],
        byDepartmentAnual: byDepartmentData?.data?.anualEvolution || [],
        byDepartmentMonth: byDepartmentData?.data?.monthEvolution || [],
        byPoliceStationAnual: byPoliceStationData?.data?.anualEvolution || [],
        byPoliceStationMonth: byPoliceStationData?.data?.monthEvolution || []
    }

    return (
        <PoliceChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </PoliceChartsDataContext.Provider>
    );
};

export default PoliceChartsDataProvider;
